/**
 * Breakpoints configuration for Material-UI v7 theme
 * Migrated from legacy Gatsby theme with custom breakpoints
 */

/**
 * Custom breakpoints values for climate application
 * Optimized for data visualization and responsive design
 */
export const breakpointValues = {
  xs: 0,      // Extra small devices (phones)
  sm: 640,    // Small devices (landscape phones)
  md: 960,    // Medium devices (tablets)
  lg: 1200,   // Large devices (desktops)
  xl: 1536,   // Extra large devices (large desktops)
};

/**
 * Additional custom breakpoints for specific use cases
 */
export const customBreakpoints = {
  mobile: 500,     // Legacy mobile breakpoint
  tablet: 768,     // Standard tablet breakpoint  
  desktop: 1024,   // Standard desktop breakpoint
  wide: 1600,      // Wide screen breakpoint for dashboards
};

/**
 * Breakpoints configuration for MUI v7
 */
export const breakpoints = {
  values: breakpointValues,
  
  // Custom breakpoint keys for the theme
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  
  // Step increment for media queries
  step: 5,
};

/**
 * Media query helpers for custom usage
 */
export const mediaQueries = {
  mobile: `@media (max-width: ${customBreakpoints.mobile}px)`,
  tablet: `@media (min-width: ${customBreakpoints.mobile + 1}px) and (max-width: ${customBreakpoints.tablet}px)`,
  desktop: `@media (min-width: ${customBreakpoints.desktop}px)`,
  wide: `@media (min-width: ${customBreakpoints.wide}px)`,
};

/**
 * Container max widths for each breakpoint
 */
export const containerMaxWidths = {
  xs: '100%',
  sm: '600px', 
  md: '900px',
  lg: '1200px',
  xl: '1400px',
};

export default breakpoints;
